export enum BudgetType {
    UNSPECIFIED = 'unspecified',
    BUDGETED = 'budgeted',
    THROUGH_INVOICED = 'through-invoiced',
}
